import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class DiscountsService {
  fetchIndex(params) {
    return securedAxiosInstance.get("/discounts", { params: toSnakeCase(params) });
  }

  create(params) {
    return securedAxiosInstance.post("/discounts", toSnakeCase(params));
  }
}

export default new DiscountsService();
